import itLang from 'element-ui/lib/locale/lang/it'
const messages = {
  ...itLang,
  "banner1": "Il marchio Solplanet è un brand di AISWEI",
  "banner2": "precedentemente conosciuta come SMA China",
  "banner3": "Solare per Tutti",
  "english": "Inglese",
  "polish": "Polacco",
  "spanish": "Spagnolo",
  "germany": "Tedesco",
  "turkish": "Turco",
  "french": "Francese",
  "italian": "Italiano",
  "systemData1": "Sistema",
  "installationLocation1": "Installazione",
  "customerData1": "Cliente",
  "claimData": "Reclamo",
  "shippingAddress1": "Spedizione",
  "customerData": "Dati del Cliente",
  "customerType": "Tipo di Richiedente",
  "selectCustomer": "Seleziona il tipo di richiedente",
  "--None--": "--Nessuno--",
  "Installer": "Installatore",
  "End-customer": "Cliente Finale",
  "Distributor": "Distributore",
  "EPC": "EPC",
  "Other": "Altro",
  "companyName": "Nome dell'azienda",
  "typeCompanyName": "Inserisci il nome dell'azienda",
  "contacts": "Nome del contatto",
  "typeContacts": "Inserisci il nome del contatto",
  "contactInformation": "Numero di telefono",
  "typeContactInformation": "Inserisci il numero di telefono",
  "shippingAddress": "Indirizzo di Spedizione (Nota: Questo indirizzo sarà utilizzato come indirizzo di spedizione in caso di cambio)",
  "country": "Paese",
  "typeCountry": "Inserisci il paese",
  "province": "Provincia",
  "typeProvince": "Inserisci la provincia",
  "city": "Città",
  "typeCity": "Inserisci città",
  "area": "Via",
  "typeArea": "Inserisci l'indirizzo completo (fino al numero civico)",
  "contacts01": "Telefono cellulare",
  "typeContacts01": "Inserisci il telefono cellulare",
  "postCode": "Codice postale",
  "typePostCode": "Inserisci il codice postale",
  "email": "Email",
  "typeEmail": "Inserisci l'email",
  "errorEmail": "Inserisci indirizzo email valido.",
  "installationLocation": "Posizione dell'installazione (usa l'indirizzo di spedizione)",
  "purchaseDate": "Data di Acquisto",
  "typePurchaseDate": "Inserisci la data di acquisto",
  "installDate": "Data di Installazione",
  "typeInstallDate": "Inserisci la data di installazione",
  "faultyDeviceType": "Tipo di Dispositivo difettoso",
  "selectFaultyDeviceType": "Seleziona il tipo di dispositivo difettoso",
  "faultDate": "Data di Guasto",
  "typeFaultDate": "Inserisci la data di guasto",
  "deviceSerialNumber": "Numero di serie del dispositivo",
  "typeDeviceSerialNumber": "Inserisci il numero di serie del dispositivo",
  "faultySymptom": "Sintomo difettoso",
  "selectFaultySymptom": "Seleziona il sintomo difettoso",
  "errorDescription": "Descrizione dettagliata dell'errore",
  "typeErrorDescription": "Inserisci una descrizione dettagliata dell'errore",
  "purchaseFileId": "Voucher di Acquisto (allegato)",
  "purchaseDesc": "La prova d'acquisto deve includere il nome del cliente, l'indirizzo di installazione, il modello dell'inverter e l'indicazione che è stato pagato",
  "breakFileId": "Certificato di Guasto (allegato)",
  "breakDesc": "Si prega di inviare una foto dei dettagli del difetto, del messaggio di errore e dell'adesivo con il numero di serie del prodotto",
  "upload": "Carica",
  "systemData": "Dati del Sistema (opzionale)",
  "systemData01": "È la prima richiesta da questo sito?",
  "Yes": "Sì",
  "No": "No",
  "Unknown": "Sconosciuto",
  "systemData02": "Stato operativo di altri inverter nello stesso sito",
  "systemData03": "Motivo della richiesta precedente",
  "enterSystemData03": "Inserisci il motivo della richiesta precedente",
  "systemData04": "Dettaglio guasto di altri inverter nello stesso sito",
  "enterSystemData04": "Per favore, inserisci i dettagli del guasto degli altri inverter nello stesso sito",
  "systemData05": "In condizioni ambientali di installazione dell'inverter",
  "systemData0501": "Interno",
  "systemData0502": "Esterno (sotto la copertura dell'edificio o montare un'edicola)",
  "systemData0503": "Esterno (esposizione diretta all'inverter alla luce solare)",
  "systemData0504": "Sopra l'acqua",
  "systemData0505": "Altro",
  "systemData06": "Condizioni ambientali di installazione dei pannelli solari",
  "systemData0601": "A terra",
  "systemData0602": "Sul tetto",
  "systemData0603": "Sulla superficie dell'acqua",
  "systemData0604": "Altro",
  "systemData07": "Marca e modello dei pannelli solari",
  "typeSystemData07": "Inserisci marca e modello dei pannelli solari",
  "systemData08": "Modalità PV",
  "systemData0801": "Indipendente",
  "systemData0802": "Parallelo",
  "pleaseSelect": "Seleziona",
  "add": "Aggiungi",
  "delete": "Elimina",
  "pv10": "Pannelli solari in serie (pezzi)",
  "pv101": "Pannelli solari in serie PV1 (pezzi)",
  "pv102": "Pannelli solari in serie PV2 (pezzi)",
  "pv103": "Pannelli solari in serie PV3 (pezzi)",
  "pv104": "Pannelli solari in serie PV4 (pezzi)",
  "circuit01": "Tensione a circuito aperto (V)",
  "alternatingVoltage": "Tensione alternata",
  "l1l2": "Tensione AC L1 - L2 (V)",
  "l1n": "Tensione AC L1 - N (V)",
  "l2l3": "Tensione AC L2 - L3 (V)",
  "l2n": "Tensione AC L2 - N (V)",
  "l1l3": "Tensione AC L1 - L3 (V)",
  "l3n": "Tensione AC L3 - N (V)",
  "l1pe": "Tensione AC L1 - PE (V)",
  "l3pe": "Tensione AC L3 - PE (V)",
  "l2pe": "Tensione AC L2 - PE (V)",
  "npe": "Tensione AC N - PE (V)",
  "complaintFileId": "Allegato",
  "activeTip": "Nota: Maggiori informazioni dettagliate sull'installazione che puoi fornire, più rapidamente possiamo identificare il problema",
  "submitBtn": "Invia",
  "pleaseType": "Inserisci",
  "submitSuccess": "Invio avvenuto",
  "submitDesc": "Alcuni campi obbligatori non sono compilati, ti preghiamo di inviare nuovamente dopo la conferma. Grazie!",
  "typeUpload": "Si prega di caricare",
  "resetUpload": "Ricarica",
  "selectErrorMessage": "Seleziona il messaggio di errore",
  "errorMessage": "Altro",
  "MPPT": "MPPT",
  "chinese": "Cinese",
  "dutch": "Olandese",
  "hungary": "Ungherese",
  "termswebsite": "https://solplanet.net/it/privacy/",
  "terms": "Accetto i Termini e le Condizioni di Solplanet",
  "iagree": "Accetto i Termini e le Condizioni di Solplanet",
  "language": "Lingua",
  "ptbr": "Portoghese (Brasile)",
  "zhtw": "Cinese Tradizionale",
  "documentTitle": "Garanzia │ Solplanet",
  "validateNumber": "Inserisci un numero intero,"
}
export default messages



// WEBPACK FOOTER //
// ./src/widgets/i18n/italian.js